module.exports = __webpack_public_path__ + "static/media/Social_Icons-02.232b36ce.svg";